import { cn } from "@/lib/cn";

interface FormErrorProps {
  /** The error message to display. Renders nothing if falsy. */
  message?: string;
  "data-testid"?: string;
  className?: string;
}

export function FormError({
  message,
  "data-testid": testId,
  className,
}: FormErrorProps) {
  if (!message) return null;

  return (
    <div
      className={cn(
        "rounded-control bg-danger-muted px-appkit-md py-appkit-sm text-appkit-body text-danger",
        className,
      )}
      role="alert"
      data-testid={testId}
    >
      {message}
    </div>
  );
}
